<template>
    <v-toolbar dark fixed id="header">
        <v-toolbar-title class="mr-4">
        <v-img :src="require('@/assets/abm-logo-transparent-white-text-500x110.png')" contain height="150" width="200" />
        </v-toolbar-title>
        <v-toolbar-title class="mr-4">
                NeuroTraining {{portalVersion}}
        </v-toolbar-title>
        <v-toolbar-items>
            <v-btn flat v-if="$store.state.isUserLoggedIn" >
                {{$store.state.user.username}}
            </v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
            <v-btn flat dark
                v-if="$store.state.isTrainerLoggedIn"
                 :to="{name: 'reviewAnswers'}">
                    Review Answers
            </v-btn>
            <v-btn flat dark 
                v-if="$store.state.isUserLoggedIn"
               :to="{name: 'trainingCourse'}">
                    Go To Training
            </v-btn>
            <v-btn flat dark
                v-if="$store.state.isUserLoggedIn"
               :to="{name: 'contactUs'}">
                    Resources
            </v-btn>
            <v-btn flat dark
                v-if="$store.state.isAdminLoggedIn || $store.state.isTrainerLoggedIn"
               :to="{name: 'signature'}">
                    Upload signature
            </v-btn>
            <v-btn flat dark
                :to="{name: 'users', query:{search:this.$store.state.searchVal}}">
                    Users
                </v-btn>
            <v-btn flat dark v-if="$store.state.user.username == 'admin'"
                :to="{name: 'builder'}">
                    Builder
            </v-btn>
            <v-btn flat dark v-if="$store.state.isAdminLoggedIn"
                :to="{name: 'logs'}">
                    Logs
            </v-btn>
            <v-btn flat dark
                v-if="$store.state.isAdminLoggedIn || $store.state.isTrainerLoggedIn"
                @click="logout">
                    Log Out
            </v-btn>
            
        </v-toolbar-items>
         <v-menu class="hidden-md-and-up">
              <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
              <v-toolbar-items >
                  <v-list>
                      <v-list-tile flat dark
                            v-if="$store.state.isUserLoggedIn"
                        :to="{name: 'trainingCourse'}">
                                <v-list-tile-title>Go To Training Page</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile flat dark
                            v-if="$store.state.isUserLoggedIn"
                        :to="{name: 'contactUs'}">
                                <v-list-tile-title>Resources</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                        flat dark
                            :to="{name: 'users'}">
                            <v-list-tile-title>Users</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                        flat dark
                            :to="{name: 'signature'}">
                            <v-list-tile-title>Upload signature</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                        flat dark 
                            v-if="$store.state.user.username == 'admin'"
                            :to="{name: 'builder'}">
                            <v-list-tile-title>Builder</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                        flat dark v-if="$store.state.isAdminLoggedIn"
                            :to="{name: 'logs'}">
                            <v-list-tile-title>Logs</v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile
                        flat dark
                            v-if="$store.state.isAdminLoggedIn || $store.state.isTrainerLoggedIn"
                            @click="logout">
                                 <v-list-tile-title>Log Out</v-list-tile-title>
                        </v-list-tile>
                  </v-list>
              </v-toolbar-items>
         </v-menu>
    </v-toolbar>

</template>

<script>


export default {
    methods: {
        logout(){
            this.$store.dispatch('setToken', null)
            this.$store.dispatch('setUser', null)
            this.$store.dispatch('setAdmin', false)
            this.$store.dispatch('setTrainer', false)
            this.$store.dispatch('setSuperAdmin', false)
            this.$store.dispatch('isAdminLoggedIniner', false)
            this.$store.dispatch('logout')
            this.$router.push({
                name: 'login'
            })
        }
    }
}
</script>




<style scoped>
#header {
    background: #548FD0;
    background-color: #548FD0;
}
</style>
